import { render, staticRenderFns } from "./NshopOrderList.vue?vue&type=template&id=632df0a6&scoped=true&"
import script from "./NshopOrderList.vue?vue&type=script&lang=js&"
export * from "./NshopOrderList.vue?vue&type=script&lang=js&"
import style0 from "./NshopOrderList.vue?vue&type=style&index=0&id=632df0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632df0a6",
  null
  
)

export default component.exports